import { Routes, Route } from "react-router-dom";
import LayoutRoot from "./pages/Root";
import Page from "./pages/Page";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LayoutRoot />}>
        <Route index element={<Page />} />
        <Route path="*" element={<Page />} />
      </Route>
    </Routes>
  );
}

export default App;
